<template>
   <div class="xuanfu-wrapper" ref="moveDiv" @mousedown.prevent="startDrag" @mousemove="onDrag" @mouseup="stopDrag">
    <!-- 展开菜单 -->
    <transition name="menu-fade">
      <div class="kf-menu" :class="{ 'menu-left': menuOnLeft }" v-if="showMenu" @mousedown.stop @mousemove.stop @mouseup.stop>
        <div class="kf-item" @click.stop="onCustomer">
          <i class="el-icon-chat-dot-round"></i>
          <span>即时通话</span>
        </div>
        <div class="kf-item">
          <i class="el-icon-phone-outline"></i>
          <span>客服电话</span>
          <div class="phone-tip">400 088 3316</div>
        </div>
      </div>
    </transition>
    <!-- 悬浮球 -->
    <div class="xuanfu" @click="toggleMenu">
      <img class="img-kf" :src="iconSrc" />
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        iconSrc:'/static/images/一一.png',
        isDragging:false,
        startCoords:{x:0,y:0},
        currentCoords:{x:0,y:0},
        debouncedOnDrags:null,
        showMenu:false,
        hasMoved:false,
        menuOnLeft:false,
        menuWasOpen:false,
      };
    },
    methods:{
      toggleMenu(){
        if(this.hasMoved){
          // 发生了拖动，关闭菜单
          this.showMenu = false;
        } else {
          // 没有拖动，切换菜单状态
          this.showMenu = !this.menuWasOpen;
          if(this.showMenu){
            this.updateMenuPosition();
          }
        }
        this.hasMoved = false;
      },
      updateMenuPosition(){
        this.$nextTick(() => {
          const wrapper = this.$refs.moveDiv;
          if(!wrapper) return;
          const rect = wrapper.getBoundingClientRect();
          const ballCenterX = rect.left + rect.width / 2;
          // 球在屏幕左半边时，菜单弹到右侧
          this.menuOnLeft = ballCenterX < window.innerWidth / 2;
        });
      },
      onCustomer() {
        let routeUrl = this.$router.resolve({path: '/chat'})
        window.open(routeUrl.href, '_blank');
      },
      debounce(func,delay){
        let timer;
        return function(...args){
          if(timer)clearTimeout(timer);
          timer = setTimeout(()=>{
            func.apply(this,args);
          },delay);
        };
      },
      debouncedOnDrag(event){
        this.onDrag(event);
      },
      startDrag(event){
        this.isDragging = true
        this.menuWasOpen = this.showMenu
        this.startCoords = {
          x:event.clientX - this.currentCoords.x,
          y:event.clientY - this.currentCoords.y,
        };
      },
      onDrag(event){
        event.preventDefault();
        if(this.isDragging){
          const newCoords = {
            x:event.clientX - this.startCoords.x,
            y:event.clientY - this.startCoords.y,
          };
          // 判断是否真的发生了拖动（超过5px阈值）
          if(Math.abs(newCoords.x - this.currentCoords.x) > 5 || Math.abs(newCoords.y - this.currentCoords.y) > 5){
            this.hasMoved = true;
            this.showMenu = false;
          }
          this.currentCoords = newCoords;
          // 更新元素位置
          const target = this.$refs.moveDiv;
          target.style.transform = `translate(${this.currentCoords.x}px,${this.currentCoords.y}px)`;
        }
      },
      stopDrag() {
        this.isDragging = false;
      },
      initDebouncedOnDrag(){
        this.debouncedOnDrags = this.debounce((event)=>{
          this.onDrag(event);
        },16)
      }
    },
    mounted(){
      this.initDebouncedOnDrag();
      document.addEventListener('mousemove',this.debouncedOnDrag);
      document.addEventListener('mouseup',this.stopDrag);
      // 默认垂直居中
      this.$nextTick(() => {
        const el = this.$refs.moveDiv;
        if(el){
          const elH = el.offsetHeight || 70;
          this.currentCoords.y = (window.innerHeight - elH) / 2 + window.innerHeight * 0.1;
          el.style.transform = `translate(${this.currentCoords.x}px,${this.currentCoords.y}px)`;
        }
      });
    },
    beforeDestroy(){
      document.removeEventListener('mousemove',this.debouncedOnDrag);
      document.removeEventListener('mouseup',this.stopDrag);
    }
  }
</script>

<style scoped>
.xuanfu-wrapper {
  position: fixed;
  top: 0;
  right: 50px;
  z-index: 999;
}

/* 悬浮球 */
.xuanfu {
  width: 70px;
  height: 70px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  z-index: 2;
}
.xuanfu .img-kf {
  width: 70px;
  height: 90px;
  z-index: 1;
  position: absolute;
  top: 2px;
  left: -1px;
}
.xuanfu::before{
  content: '';
  position: absolute;
  left:-5px;
  width: 120%;
  height: 120%;
  rotate: -45deg;
  background: linear-gradient(#81ffef,#8ec1ff,#ff91c8);
}
.xuanfu:hover::before{
  animation: rotate 1s linear infinite;
}
@keyframes rotate{
  from{ transform:rotate(0deg) }
  to{ transform:rotate(360deg) }
}
.xuanfu::after{
  content: '';
  position: absolute;
  background:white;
  inset: 4px;
  border-radius: 50%;
}

/* 客服菜单 - 默认在左侧，垂直居中对齐悬浮球 */
.kf-menu {
  position: absolute;
  right: 75px;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 8px 0;
  min-width: 140px;
  z-index: 1;
}

/* 菜单在右侧 */
.kf-menu.menu-left {
  right: auto;
  left: 75px;
}

.kf-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.2s;
  position: relative;
  font-size: 14px;
  color: #333;
  gap: 8px;
}

.kf-item:hover {
  background: rgba(24, 144, 255, 0.08);
  color: #1890ff;
}

.kf-item i {
  font-size: 18px;
}

.phone-tip {
  display: none;
  position: absolute;
  left: -130px;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.12);
  padding: 6px 12px;
  white-space: nowrap;
  font-size: 13px;
  color: #1890ff;
  font-weight: 500;
}

.phone-tip::before {
  content: '';
  position: absolute;
  right: -6px;
  top: 50%;
  transform: translateY(-50%);
  border: 6px solid transparent;
  border-left-color: #fff;
  border-right: none;
}

/* 菜单在右侧时，电话提示弹到左边 */
.menu-left .phone-tip {
  left: auto;
  right: -130px;
}

.menu-left .phone-tip::before {
  right: auto;
  left: -6px;
  border-left-color: transparent;
  border-right-color: #fff;
  border-left: none;
  border-right: none;
}

.kf-item:hover .phone-tip {
  display: block;
}

/* 菜单过渡动画 */
.menu-fade-enter-active, .menu-fade-leave-active {
  transition: all 0.25s ease;
}
.menu-fade-enter, .menu-fade-leave-to {
  opacity: 0;
  transform: translateY(-50%) translateX(10px);
}
</style>



// WEBPACK FOOTER //
// tools.vue?57e744de